module.exports = __webpack_public_path__ + "static/media/40.3c85b8b7.mp3";